const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-2 text-center fixed bottom-0 right-0 left-0 text-xs ">
      <p>&copy; QeApps 2025 Interview System. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
